module.exports = __webpack_public_path__ + "static/media/S1N7-3.31c14d7f.svg";